export default "__VITE_ASSET__gcuJn28h__"